import { useState } from 'react';
import { components } from 'react-select';

export const fetchIp = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();

        return { status: true, data: data?.ip }
    } catch (error) {
        console.error('Error fetching IP address:', error);

        return { status: false, data: null }
    }
};


export const SelectDropDownCheckboxInputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
}) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    if (isFocused) bg = "#eee";
    if (isActive) bg = "#B2D4FF";

    const style = {
        alignItems: "center",
        backgroundColor: bg,
        color: "inherit",
        display: "flex "
    };

    // prop assignment
    const props = { ...innerProps, onMouseDown, onMouseUp, onMouseLeave, style };

    return (
        <components.Option
            {...rest}
            isDisabled={isDisabled}
            isFocused={isFocused}
            isSelected={isSelected}
            getStyles={getStyles}
            innerProps={props}
        >
            <span className='position-relative'>
                <input className='form-check-input dropdowncheckbox' type="checkbox" checked={isSelected} readOnly />
                <span className='dropdownvalue'>
                    {children}
                </span>
            </span>
        </components.Option>
    );
};

export function areArraysEqualIgnoreOrder(arr1, arr2) {
    if (arr1?.length !== arr2?.length) return false;

    const sorted1 = [...arr1]?.sort((a, b) => a - b);
    const sorted2 = [...arr2]?.sort((a, b) => a - b);

    return sorted1?.every((value, index) => value === sorted2?.[index]);
}